module.exports = __webpack_public_path__ + "static/media/rainy.2bd23641.svg";